<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <div class="planner-container">
      <div class="calendar-section">
        <app-calendar
          [markedDates]="calendarMarkedDates()"
          [loading]="calendarLoading()"
          (daySelected)="onDaySelected($event)"
          (monthChanged)="onMonthChanged($event)"
        />
      </div>

      @if (selectedDate()) {
        <div class="activities-section">
          @if (activitiesLoading()) {
            <div class="activities-grid">
              @for (i of [1, 2, 3, 4, 5, 6]; track i) {
                <div class="activity-card-skeleton">
                  <app-wiper-loading />
                </div>
              }
            </div>
          } @else if (activities().length > 0) {
            @if (hasBothTypes()) {
              <div class="view-toggle">
                <button
                  class="toggle-btn"
                  [class.active]="activeViewTab() === 'visits'"
                  (click)="switchViewTab('visits')"
                >
                  {{ dictionaryService.get('Visits') || 'Visits' }}
                  <span class="toggle-count">{{ singleVisits().length }}</span>
                </button>
                <button
                  class="toggle-btn"
                  [class.active]="activeViewTab() === 'nfa'"
                  (click)="switchViewTab('nfa')"
                >
                  {{ dictionaryService.get('NFA') || 'NFA' }}
                  <span class="toggle-count">{{ nfaActivities().length }}</span>
                </button>
              </div>
            }
            <div class="activities-grid">
              @for (activity of displayedActivities(); track $index) {
                <div class="activity-card {{ getActivityStatusClass(activity.Status) }}">
                  <span class="activity-customer">{{ activity.eventType === 'NFA' ? activity.NFA : activity.Customer }}</span>
                  <span class="activity-type">{{ getActivityStatusLabel(activity.Status) }}</span>
                </div>
              }
            </div>
          } @else {
            <div class="activities-empty">
              <span>{{ dictionaryService.get('NoDataAvailable') || 'No activities found' }}</span>
            </div>
          }
        </div>
      }
    </div>
  }
</app-tab-layout>
